module.exports = __webpack_public_path__ + "static/media/Tischdecke_140x220.4fc6585b.png";